import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Injectable } from "@angular/core";
import { removeTokenFromUrl } from 'src/app/utils/url-utils';

declare global {
    interface Window {
        DD_RUM: any;
        DD_LOGS: any;
    }
}

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.logError(req);

        return next.handle(req).pipe(catchError(this.handleError));
    }

    private logError(req: HttpRequest<any>) {
        try {
            // This is being called for every call and is creating large number of events to Sentry
            // Uncomment while debugging
            // Sentry.captureMessage(`${this.cleanRequestObject(deepClone(req))}`, Sentry.Severity.Debug);
        } catch (e) {}
    }

    private handleError(error: any, caught: any): Observable<any> {
        try {
            // Clean the error object before logging
            const sanitizedError = this.sanitizeErrorForLogging(error);
            window.DD_LOGS.logger.error(sanitizedError);
        } catch (e) {}

        return throwError(error);
    }

    private sanitizeErrorForLogging(error: any): any {
        if (error == null) return error;
        const visit = (value: any, parentKey?: string): any => {
            if (value == null) return value;
            if (typeof value === 'string') {
                // If the key hints at a token, fully mask; otherwise scrub token-like substrings/URLs.
                return parentKey && parentKey.toLowerCase().includes('token')
                    ? '***'
                    : removeTokenFromUrl(value);
            }
            if (Array.isArray(value)) {
                return value.map(v => visit(v));
            }
            if (typeof value === 'object') {
                const out: any = {};
                Object.keys(value).forEach(k => {
                    out[k] = visit((value as any)[k], k);
                });
                return out;
            }
            return value;
        };
        return visit(error);
    }

    // Remove unwanted information from request object that we don't want to track
    private cleanRequestObject(request: HttpRequest<any>): HttpRequest<any> {
        if (request['body']) {
            // If request object contains email remove it
            if (request['body'].hasOwnProperty('email') && request['body'].email.length > 0) request['body'].email = 'email removed';
            // If request object contains password remove it
            if (request['body'].hasOwnProperty('password') && request['body'].password.length > 0) request['body'].password = 'password removed';
        }

        // Remove JWT from request object
        if (request.headers.get('X-JWT'))
            request = request.clone({ setHeaders: { 'X-JWT': '***' } });

        return request;
    }
}
